module.exports = __webpack_public_path__ + "img/加入我们_p1.eb882982.png";